import {
  createRequestTypes,
  START,
  SUCCESS,
  ERROR,
} from '@modules/appraisal/actions/global';
import { makeApiActionCreatorV3 } from '@actions/utils';
/* import * as eventApi from '@modules/events/api/event'; */
import * as api from '@modules/litigation/api/litigation';

const namespace = 'LITIGATION';

export const FETCH_APPRAISER_CASES = createRequestTypes(
  `${namespace}/FETCH_APPRAISER_CASES`,
);

export const fetchAppraiserCases = makeApiActionCreatorV3(
  api.fetchAppraiserCases,
  FETCH_APPRAISER_CASES[START],
  FETCH_APPRAISER_CASES[SUCCESS],
  FETCH_APPRAISER_CASES[ERROR],
);

export const FETCH_APPRAISER_LITIGATION_CASES = createRequestTypes(
  `${namespace}/FETCH_APPRAISER_LITIGATION_CASES`,
);

export const fetchAppraiserLitigationCases = makeApiActionCreatorV3(
  api.fetchAppraiserLitigationCases,
  FETCH_APPRAISER_LITIGATION_CASES[START],
  FETCH_APPRAISER_LITIGATION_CASES[SUCCESS],
  FETCH_APPRAISER_LITIGATION_CASES[ERROR],
);

export const FETCH_APPRAISERS = createRequestTypes(
  `${namespace}/FETCH_APPRAISERS`,
);

export const fetchAppraisers = makeApiActionCreatorV3(
  api.fetchAppraisers,
  FETCH_APPRAISERS[START],
  FETCH_APPRAISERS[SUCCESS],
  FETCH_APPRAISERS[ERROR],
);

export const FETCH_USERS = createRequestTypes(`${namespace}/FETCH_USERS`);

export const fetchUsers = makeApiActionCreatorV3(
  api.fetchUsers,
  FETCH_USERS[START],
  FETCH_USERS[SUCCESS],
  FETCH_USERS[ERROR],
);
